import { BasePage } from '@/components/ui/base-page'

export function TokensPage() {
  return (
    <BasePage
      title="Tokens & Tokenization"
      description="Tokenization of assets and instruments for fractional ownership and digital access."
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>We offer exposure to tokenized assets and instruments, enabling fractional ownership and efficient transfer of value. Content and offerings can be expanded here.</p>
      </div>
    </BasePage>
  )
}
